module.exports = __webpack_public_path__ + "img/panch_cuento_5.86b31dcc.png";